import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '../../contexts/AuthContext';
import AdminRouter from './AdminRouter';
import '../layout/AdminLayout.css';

// Create a separate client for admin
const adminQueryClient = new QueryClient();

const AdminApp = () => {
  return (
    <QueryClientProvider client={adminQueryClient}>
      <AuthProvider>
        <div className="admin-app">
          <AdminRouter />
          <Toaster position="top-right" />
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default AdminApp;
